export default __webpack_public_path__ + "static/img/prom.0d966ed.png";